// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

// utilities
import _ from 'lodash';

// components
import Logo from '../../common/svgs/Logo';
import fixLines from '../../lib/fixLines';
import prettyPhone from '../../lib/prettyPhone';
import { toYear, resumeDate } from '../../lib/prettyDate';
import prettyAddress from '../../lib/prettyAddress';

// styling objects

// redux action creators
import * as asyncActionCreators from '../../redux/actionCreators/async';

const WAHVE_ACCOUNT_HARDCODELINK = 'WAHVE';

@connect((state, props) => {
  const root = props.location.pathname.split('/')[1];
  return {
    profile         : state.applicantProfile,
    user            : root === 'admin' ? state.applicantUser : state.user.impersonateUser || state.user,
    workExperiences : state.workExperiences,
    skills          : state.skills,
    education       : state.education,
    licenses        : state.licenses,
    designations    : state.designations,
    associations    : state.associations,
    staticData      : state.staticData
  };
}, ({
  getProfileById: asyncActionCreators.getProfileById
}))

export default class ApplicantResume extends Component {
  static propTypes = {
    params          : PropTypes.func.isRequired,
    getProfileById  : PropTypes.func.isRequired,
    profile         : PropTypes.object,
    user            : PropTypes.object,
    workExperiences : PropTypes.object,
    skills          : PropTypes.object,
    education       : PropTypes.object,
    licenses        : PropTypes.object,
    designations    : PropTypes.object,
    staticData      : PropTypes.object,
    location        : PropTypes.object
  }

  constructor() {
    super();
  }

  componentWillMount() {
    const profileId = this.props.params.profileId || this.props.user.profileId;
    if(profileId && (_.isEmpty(this.props.profile)  || _.isEmpty(this.props.workExperiences))) {
      this.props.getProfileById(profileId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const profileId = nextProps.params.profileId || nextProps.user.profileId;
    if (profileId && (_.isEmpty(this.props.profile))) {
      this.props.getProfileById(profileId);
    }
  }

  getState(value) {
    const state = _.find(this.props.staticData.stateList, (s) => { return s.id === value; });
    return _.get(state, 'name', '');
  }

  getLicenseType(license) {
    const { staticData : { licenseTypes = {} } } = this.props;
    const type = _.find(licenseTypes, (s) => { return s.id === license.licenseTypeId; });
    return [_.get(type, 'name'), license.licenseName]
      .filter(s => !!s)
      .reduce((name, curr) => name !== 'Other' ?  name : curr)
    ;
  }

  getDates(value, value2, isCurrent) {
    const dates = [];
    if (value) {
      dates.push(resumeDate(value));
    }

    if (isCurrent) {
      dates.push('Current');
    }
    else if (value2) {
      dates.push(resumeDate(value2));
    }
    return dates.join(' - ');
  }

  getPhoneNumber(value, value2, value3) {
    if (!_.isEmpty(value)) {
      return prettyPhone(value);
    }
    if (!_.isEmpty(value2)) {
      return prettyPhone(value2);
    }
    if (!_.isEmpty(value3)) {
      return prettyPhone(value3);
    }
  }

  getComputerSkills() {

    const { skillCategoryTypes } = this.props.staticData;
    const { skills } = this.props;
    const computerSkills = skillCategoryTypes
      .filter(type => type && type.sub_category === 'Computer')
      .map(type => type.id)
      .reduce((compSkills, categoryId) => {
        if (skills[categoryId]) {
          return _.merge(compSkills, skills[categoryId]);
        }
        return compSkills;
      }, {})
    ;

    return _.filter(computerSkills, skill => skill.name !== 'None' && skill.skillLevelName !== 'Beginner');
  }

  getDegreeName(item) {

    if (item.degreeName === 'Other') {
      return item.degreeTypeOther;
    }
    else if(item.degreeName === 'None') {
      return 'No degree';
    }

    return item.degreeName;

  }

  getAttendedDates(item) {
    const dates = [];
    if (item.dateAttendedStart) {
      dates.push(toYear(item.dateAttendedStart));
    }
    if (item.dateAttendedEnd) {
      dates.push(toYear(item.dateAttendedEnd));
    }
    return dates.join(' - ');
  }

  getEducation(item) {
    const education = [];
    const degree = this.getDegreeName(item);
    if (!_.isEmpty(degree)) {
      education.push(degree);
    }
    education.push(item.subjectOrMajor);

    if (!_.isEmpty(item.creditsEarned)) {
      education.push(`${item.creditsEarned} Credits`);
    }
    education.push(item.institutionName);
    education.push(this.getAttendedDates(item));
    return education.join(', ');
  }

  getAbbreviation(value) {
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(value);
    return matches ? matches[1] : value;
  }

  mapObject(object, callback) {
    return Object.keys(object).map((key) => {
      return callback(object[key], key);
    });
  }

  renderComputerSkills() {

    const computerSkills = this.getComputerSkills();
    if (!_.isEmpty(computerSkills)) {

      return (
        <div className='section' data-id='Computer Skills'>
          <div className='title'>Computer Skills</div>
          <ul className='computer-skill'>
          {
            _.map(computerSkills, (skill) =>
              <li className='item'>{skill.name}</li>
            )
          }
          </ul>
        </div>
      );

    }

  }

  renderLicenses(props) {

    const { licenses, profile = {}, staticData = {} } = props;
    const { applicantLicenseStatus = [] } = staticData;
    const isLicensed = !!applicantLicenseStatus
                          .filter(s => s.subElement === 'Licensed')
                          .find(s => s.id === profile.licenseStatus)
                          ;

    if (_.isEmpty(props.licenses) || !isLicensed) {
      return;
    }

    const renderLicenseName = (state, type) =>
      [state, type]
        .filter(l => !!l)
        .join(' - ')
      ;

    return (
      <div className='section' data-id='Licenses'>
        <div className='title'>Licenses</div>
        <ul className='licenses'>
        {
          this.mapObject(licenses, (license) =>
            <li className='license-item'>{renderLicenseName(this.getState(license.state), this.getLicenseType(license))} </li>
          )
        }
        </ul>
      </div>
    );

  }

  render() {

    if (_.isEmpty(this.props.profile)) {
      return null;
    }

    return (
      <div className='applicant-resume clearfix'>
        <Logo className='resume-logo' />
        {
        !_.isEmpty(this.props.user) &&
        !_.isEmpty(this.props.profile) &&
        <div className='center-container'>
          <div className='info-container section' data-id='Contact Info'>
            <div className='left'>
              <div className='name'>{this.props.user.firstName} {this.props.user.lastName}</div>
              <div className='address'>{prettyAddress({...this.props.user, stateName: this.getState(this.props.user.state)})}</div>
            </div>
            <div className='right'>
              <div className='email'>{this.props.user.email}</div>
              <div className='phone'>{this.getPhoneNumber(this.props.user.phoneNumber1, this.props.user.phoneNumber2, this.props.user.phoneNumber3)}</div>
            </div>
          </div>
          {
            !_.isEmpty(this.props.profile.careerSummary)
            &&
            <div className='career-summary section' data-id='Career Summary'>
              <div className='title'>Career Summary</div>
              <div className='text'>{fixLines(this.props.profile.careerSummary)}</div>
            </div>
          }
          {
            !_.isEmpty(this.props.workExperiences)
            &&
            <div className='work-experiences section' data-id='Work Experiences'>
              <div className='title'>Work Experience</div>
              {
                this.mapObject(_({})
                  .merge(this.props.workExperiences)
                  .orderBy(['current', 'employmentEnd', 'employmentStart'], ['desc', 'desc', 'desc'])
                  .value(),  (experience) =>
                  <div className='sub-section'>
                    <div className='left'>
                      <div className='company'>{experience.employerName}</div>
                      <div className='job-title'>{experience.title}</div>
                    </div>
                    <div className='right'>
                      <div className='location'>{experience.city}, {this.getState(experience.state)}</div>
                      <div className='date'>{this.getDates(experience.employmentStart, experience.employmentEnd, experience.current)}</div>
                    </div>
                    <div className='job-summary'>{fixLines(experience.jobSummary)}</div>
                    <ul className='job-responsibilities'>
                    {
                      experience.jobSpecifics.map((responsibility) =>
                        <li className='responsibility-item'>{responsibility}</li>
                      )
                    }
                    </ul>
                  </div>
                )
              }
            </div>
          }
          {
            this.renderComputerSkills()
          }
          {
            !_.isEmpty(this.props.education)
            &&
            <div className='section' data-id='Education'>
              <div className='title'>Education</div>
              <ul className='education'>
              {
                this.mapObject(this.props.education, (item) =>
                  <li className='education-item'>{this.getEducation(item)}</li>
                )
              }
              </ul>
            </div>
          }
          {
            this.props.staticData.account.hardcodelink===WAHVE_ACCOUNT_HARDCODELINK
            &&
            this.renderLicenses(this.props)
          }
          {
            !_.isEmpty(_.filter(this.props.designations, s => s.name !== 'None'))
            &&
            <div className='section' data-id='Professional Designations'>
              <div className='title'>Professional Designations & Certifications</div>
              <ul className='designations'>
              {
                this.mapObject(this.props.designations, (designation, key) =>
                  <li className='item'>{key}</li>
                )
              }
              </ul>
            </div>
        }
        {
          !_.isEmpty(_.filter(this.props.associations, s => s.name !== 'None'))
          &&
          <div className='section' data-id='Professional Designations'>
            <div className='title'>Professional Associations</div>
            <ul className='associations'>
            {
              this.mapObject(this.props.associations, (designation, key) =>
                <li className='item'>{this.getAbbreviation(key)}</li>
              )
            }
            </ul>
          </div>
        }
        </div>
      }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantResume/index.js